// src/scripts/vendor/graphene.js
var debug = false;
var previousUrl = window.location.href;
var facetsDrawerDetails = null;
var expandedFacetGroupIds = /* @__PURE__ */ new Set();
var facetsDrawerScrollTop = 0;
var facetsApplyLoadingTimeout = null;
var facetsResultCount = null;
var lastFacetsDrawerScrollAt = 0;
var pendingFacetTap = null;
var suppressFacetClickUntil = 0;
function rendersGrapheneGrid() {
  const ac = window.advancedCommerce || {};
  return Boolean(
    ac.isCollection && ac.isCollectionEnabled || ac.isSearch && ac.isSearchEnabled
  );
}
if ("scrollRestoration" in history && rendersGrapheneGrid()) {
  history.scrollRestoration = "manual";
  if (!isHistoryNavigation() && readSavedScroll()?.path === window.location.pathname) {
    sessionStorage.removeItem("ac_collection_scroll");
  }
}
var HYDRATE_VIEWPORT_FACTOR = 1.5;
var EAGER_CARD_COUNT = 8;
function priorityCardCount() {
  return window.matchMedia("(min-width: 1024px)").matches ? 8 : 4;
}
var hydrationRuns = /* @__PURE__ */ new WeakMap();
function observeDeferredCards(run, cards, view) {
  if (!cards.length) return;
  if (typeof IntersectionObserver === "undefined") {
    cards.forEach((card) => hydrateCard(card, view));
    return;
  }
  const margin = Math.round(
    (window.innerHeight || 800) * HYDRATE_VIEWPORT_FACTOR
  );
  run.observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        run.observer.unobserve(entry.target);
        hydrateCard(entry.target, view);
      });
    },
    { rootMargin: `${margin}px 0px` }
  );
  cards.forEach((card) => run.observer.observe(card));
}
async function hydrateCardsInBatches(container, view = "ac", concurrency = 6, onBatch, { deferOffscreen = true, eagerThroughY = 0, priorityCount = 0 } = {}) {
  if (!container) return;
  hydrationRuns.get(container)?.observer?.disconnect();
  const run = {};
  hydrationRuns.set(container, run);
  const cards = Array.from(
    container.querySelectorAll(".js-dynamic-card[data-product-handle]")
  ).filter((card) => {
    return card.dataset.context !== "autocomplete" && card.dataset.enhanced !== "true" && card.dataset.loading !== "true";
  });
  if (!cards.length) return;
  const gridCards = Array.from(
    container.querySelectorAll("[data-product-handle]")
  );
  const isPriority = (card) => gridCards.indexOf(card) < priorityCount;
  const isEager = (index) => !deferOffscreen || index < EAGER_CARD_COUNT || cards[index].getBoundingClientRect().top + window.scrollY < eagerThroughY;
  let next = 0;
  const worker = async () => {
    while (next < cards.length && isEager(next)) {
      if (hydrationRuns.get(container) !== run) return;
      const index = next++;
      await hydrateCard(cards[index], view, {
        priority: isPriority(cards[index])
      });
      onBatch?.();
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(concurrency, cards.length) }, worker)
  );
  if (hydrationRuns.get(container) !== run) return;
  observeDeferredCards(run, cards.slice(next), view);
}
var swymRescanQueued = false;
function queueSwymRescan() {
  if (swymRescanQueued) return;
  swymRescanQueued = true;
  requestAnimationFrame(() => {
    swymRescanQueued = false;
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  });
}
function getGrapheneUrl(url) {
  const parsed = new URL(url, window.location.origin);
  const page = parsed.searchParams.get("page");
  if (page) {
    parsed.searchParams.delete("page");
    parsed.searchParams.set("pg", page);
  }
  return parsed.toString();
}
function getGrapheneCategoryArgs() {
  const market = window.advancedCommerce?.marketId || (typeof Shopify !== "undefined" ? Shopify.country : null);
  if (!market) return null;
  return { market: String(market).toUpperCase() };
}
function showFacetsApplyLoadingSpinner() {
  const applyBtn = document.querySelector(".js-ghc-facets-apply");
  if (!applyBtn) return;
  applyBtn.classList.add("is-loading");
  clearTimeout(facetsApplyLoadingTimeout);
  facetsApplyLoadingTimeout = setTimeout(() => {
    applyBtn.classList.remove("is-loading");
  }, 8e3);
}
function reloadGraphene(url) {
  showFacetsApplyLoadingSpinner();
  const options = { url: getGrapheneUrl(url.toString()) };
  if (window.advancedCommerce?.isCollection && window.advancedCommerce?.isCollectionEnabled) {
    const args = getGrapheneCategoryArgs();
    if (args) options.args = args;
  }
  $g.reload(options);
}
function normalizeBrowserUrl() {
  const url = new URL(window.location.href);
  const pg = url.searchParams.get("pg");
  if (pg) {
    url.searchParams.delete("pg");
    url.searchParams.set("page", pg);
    history.replaceState(null, "", url.toString());
  }
}
function didPaginationChange() {
  const prev = new URL(previousUrl);
  const curr = new URL(window.location.href);
  const prevPg = prev.searchParams.get("pg") || prev.searchParams.get("page");
  const currPg = curr.searchParams.get("pg") || curr.searchParams.get("page");
  if (prevPg !== currPg) {
    sessionStorage.removeItem("ac_collection_scroll");
  }
  return prevPg !== currPg;
}
function isHistoryNavigation() {
  const nav = performance.getEntriesByType("navigation")[0];
  return nav?.type === "back_forward";
}
function readSavedScroll() {
  try {
    return JSON.parse(sessionStorage.getItem("ac_collection_scroll"));
  } catch (err) {
    return null;
  }
}
function savedScrollDepth() {
  const y = readSavedScroll()?.y;
  return typeof y === "number" ? y + window.innerHeight : 0;
}
function findAnchorCard(anchor) {
  if (!anchor?.handle) return null;
  return Array.from(
    document.querySelectorAll(
      ":is(#collections-AC, #search-Results-AC) [data-product-handle]"
    )
  ).find(
    (card) => card.dataset.productHandle === anchor.handle && (card.dataset.variant || "") === anchor.variant
  ) || null;
}
function restoreCollectionScroll() {
  const saved = readSavedScroll();
  const card = findAnchorCard(saved?.anchor);
  if (card) {
    window.scrollTo(
      0,
      card.getBoundingClientRect().top + window.scrollY - saved.anchor.offset
    );
    return;
  }
  if (typeof saved?.y !== "number") return;
  window.scrollTo(0, saved.y);
}
document.addEventListener("click", (event) => {
  const link = event.target.closest(
    ":is(#collections-AC, #search-Results-AC) a[href]"
  );
  if (!link) return;
  const target = new URL(link.href, window.location.origin);
  if (target.pathname === window.location.pathname) return;
  const data = {
    y: window.scrollY,
    path: window.location.pathname
  };
  const card = link.closest("[data-product-handle]");
  if (card) {
    data.anchor = {
      handle: card.dataset.productHandle,
      variant: card.dataset.variant || "",
      offset: card.getBoundingClientRect().top
    };
  }
  if (debug) console.log("Saving scroll state:", data);
  sessionStorage.setItem("ac_collection_scroll", JSON.stringify(data));
});
window.addEventListener("pageshow", (event) => {
  if (!event.persisted) return;
  if (readSavedScroll()?.path !== window.location.pathname) return;
  restoreCollectionScroll();
  sessionStorage.removeItem("ac_collection_scroll");
});
var pendingScrollToTop = false;
var userScrolledDuringLoad = false;
["wheel", "touchmove", "keydown"].forEach((type) => {
  document.addEventListener(
    type,
    () => {
      userScrolledDuringLoad = true;
    },
    { passive: true }
  );
});
document.addEventListener("click", (event) => {
  const link = event.target.closest("a[href]");
  if (!link) return;
  if (!link.closest("#collections-AC, #search-Results-AC")) return;
  let target;
  try {
    target = new URL(link.href, window.location.origin);
  } catch (err) {
    return;
  }
  const current = new URL(window.location.href);
  const targetPage = target.searchParams.get("pg") || target.searchParams.get("page");
  const currentPage = current.searchParams.get("pg") || current.searchParams.get("page");
  if (targetPage && targetPage !== currentPage) {
    pendingScrollToTop = true;
    userScrolledDuringLoad = false;
    showFacetsApplyLoadingSpinner();
    scrollToResultsTop();
  }
});
function hasSavedScroll() {
  if (!isHistoryNavigation()) return false;
  const saved = readSavedScroll();
  if (!saved) return false;
  const { path } = saved;
  return !path || path === window.location.pathname;
}
function scrollToResultsTop(behavior = "smooth") {
  window.scrollTo({
    top: 0,
    behavior
  });
}
function fetchCardHtml(handle, variant, view, priority) {
  let requestView = view;
  if (variant) {
    requestView += `&variant=${variant}`;
  }
  return fetch(`${handle}?view=${requestView}`, {
    priority: priority ? "high" : "auto"
  }).then((res) => res.ok ? res.text() : "");
}
var prefetchedCards = /* @__PURE__ */ new Map();
var prefetchedHtml = /* @__PURE__ */ new Map();
var prefetchKey = (handle, variant) => `${handle}|${variant || ""}`;
function willApplyColourFilters() {
  try {
    if (localStorage.getItem("wbColour.hasChosenSeason") !== "1") return false;
  } catch (err) {
    return false;
  }
  const url = new URL(window.location.href);
  return url.searchParams.get("__wbColourApplied") !== "1";
}
function prefetchFirstScreen(html) {
  if (willApplyColourFilters()) return;
  const tags = html.match(/<product-card\b[^>]*>/g) || [];
  const priorityCount = priorityCardCount();
  tags.slice(0, EAGER_CARD_COUNT).forEach((tag, index) => {
    const handle = tag.match(/data-product-handle="([^"]+)"/)?.[1];
    if (!handle) return;
    const variant = tag.match(/data-variant="([^"]*)"/)?.[1];
    const key = prefetchKey(handle, variant);
    if (prefetchedCards.has(key)) return;
    const priority = index < priorityCount;
    const request = fetchCardHtml(handle, variant, "ac", priority).catch(
      () => ""
    );
    request.then((text) => {
      if (!text) return;
      prefetchedHtml.set(key, text);
      if (priority) preloadCardImage(text, index === 0);
    });
    prefetchedCards.set(key, request);
  });
}
function buildEarlyResults(html) {
  if (!prefetchedHtml.size) return null;
  const template = document.createElement("template");
  template.innerHTML = html;
  const filled = Array.from(
    template.content.querySelectorAll(".js-dynamic-card[data-product-handle]")
  ).slice(0, EAGER_CARD_COUNT).filter((card, index) => {
    const key = prefetchKey(card.dataset.productHandle, card.dataset.variant);
    const text = prefetchedHtml.get(key);
    if (!text) return false;
    prefetchedHtml.delete(key);
    prefetchedCards.delete(key);
    fillCard(card, parseCardHtml(text, index < priorityCardCount()));
    card.classList.remove("js-dynamic-card");
    card.dataset.enhanced = "true";
    return true;
  });
  if (!filled.length) return null;
  return {
    fragment: template.content,
    // Runs once the fragment is in the page (custom elements have upgraded by then)
    done() {
      filled.forEach(initCardImageLoaders);
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    }
  };
}
function takePrefetchedCard(handle, variant, view) {
  if (view !== "ac") return null;
  const key = prefetchKey(handle, variant);
  const request = prefetchedCards.get(key);
  prefetchedCards.delete(key);
  return request;
}
function preloadCardImage(html, highPriority) {
  const media = html.indexOf("product-card__media");
  if (media === -1) return;
  const img = html.slice(media).match(/<img\b[^>]*>/);
  if (!img) return;
  const attr = (name) => {
    const value = img[0].match(new RegExp(`\\s${name}="([^"]*)"`));
    return value ? value[1].replace(/&amp;/g, "&").trim() : "";
  };
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  if (attr("srcset")) {
    link.imageSrcset = attr("srcset");
    link.imageSizes = attr("sizes");
  } else if (attr("src")) {
    link.href = attr("src");
  } else {
    return;
  }
  if (highPriority) link.fetchPriority = "high";
  document.head.appendChild(link);
}
function parseCardHtml(html, priority) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  if (priority) {
    doc.querySelectorAll(".product-card__media img").forEach((img, i) => {
      img.loading = "eager";
      if (i === 0) img.fetchPriority = "high";
    });
  }
  return doc;
}
function fillCard(card, doc) {
  ["product-card__content", "product-card__media"].forEach((cls) => {
    const newEl = doc.querySelector(`.${cls}`);
    const existing = card.querySelector(`.${cls}`);
    if (newEl && existing) {
      existing.replaceWith(newEl);
    }
  });
  const atcSelector = ".quick-cart-drawer__trigger, .product-card__add-to-cart--form";
  const newAtc = doc.querySelector(atcSelector);
  const existingAtc = card.querySelector(atcSelector);
  if (newAtc && existingAtc) {
    existingAtc.replaceWith(newAtc);
  } else if (newAtc) {
    card.querySelector(".product-card__actions")?.appendChild(newAtc);
  } else if (existingAtc) {
    existingAtc.remove();
  }
}
async function hydrateCard(card, view = "ac", { priority = false } = {}) {
  if (!card) return;
  if (card.dataset.enhanced === "true") return;
  if (card.dataset.loading === "true") return;
  if (card.dataset.context === "autocomplete") {
    card.classList.remove("js-dynamic-card");
    card.dataset.enhanced = "true";
    return;
  }
  const handle = card.dataset.productHandle;
  if (!handle) return;
  card.dataset.loading = "true";
  try {
    const variant_id = card.dataset.variant;
    const html = await (takePrefetchedCard(handle, variant_id, view) || fetchCardHtml(handle, variant_id, view, priority));
    if (!html || !card.isConnected) return;
    const doc = parseCardHtml(html, priority);
    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        fillCard(card, doc);
        resolve();
      });
    });
    initCardImageLoaders(card);
    card.dataset.enhanced = "true";
    requestAnimationFrame(() => {
      card.classList.remove("js-dynamic-card");
    });
    queueSwymRescan();
    card.init?.();
  } catch (err) {
    console.error("Dynamic card hydrate error:", handle, err);
  } finally {
    delete card.dataset.loading;
  }
}
function swymCallbackFn(swat) {
  document.addEventListener("swym:collections-loaded", function() {
    swat.collectionsApi.initializeCollections(
      swat,
      false,
      window.Shopify.theme.theme_store_id
    );
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
function initCardImageLoaders(container) {
  const images = container.querySelectorAll(".product-card__media img");
  images.forEach((img) => {
    const media = img.closest(".product-card__media");
    applyLoadingPriority(img, media || container);
    const loader = media?.querySelector(".product-card__media-loader");
    const done = () => {
      img.classList.add("is-loaded");
      loader?.remove();
    };
    if (img.complete) {
      done();
    } else {
      img.addEventListener("load", done, { once: true });
      img.addEventListener("error", done, { once: true });
    }
  });
}
var AC_CONTAINER_SELECTOR = "#collections-AC, #search-Results-AC";
var AC_BANNER_SELECTOR = ".items-wrapper > a > img, .items-wrapper > p > a > img";
var OPTIMISED_FLAG = "acOptimised";
var BANNER_CLASS = "ac-banner";
var BANNER_IMAGE_CLASS = "ac-banner__image";
var IMAGE_WIDTH_STEP = 60;
var MIN_IMAGE_WIDTH = 240;
var MAX_IMAGE_WIDTH = 900;
function isShopifyCdnImage(url) {
  return /\/(cdn\/shop|s\/files)\//.test(url.pathname) && /\.(jpe?g|png|webp)$/i.test(url.pathname);
}
function cdnImageUrl(rawSrc, width) {
  let url;
  try {
    url = new URL(rawSrc, window.location.href);
  } catch {
    return null;
  }
  if (!isShopifyCdnImage(url)) return null;
  url.searchParams.set("width", String(width));
  url.searchParams.set("format", "webp");
  return url.toString();
}
function slotWidthFor(img) {
  const box = (img.parentElement || img).getBoundingClientRect();
  return Math.max(box.width, img.getBoundingClientRect().width);
}
function targetWidthFor(slotWidth) {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const wanted = Math.ceil(slotWidth * dpr / IMAGE_WIDTH_STEP) * IMAGE_WIDTH_STEP;
  return Math.min(Math.max(wanted, MIN_IMAGE_WIDTH), MAX_IMAGE_WIDTH);
}
var IMAGE_WIDTH_LADDER = [160, 180, 240, 300, 360, 420, 480, 600, 750, 900];
function sizesFor(slotWidth) {
  const viewport = window.innerWidth || 1440;
  const share = Math.max(
    Math.min(Math.round(slotWidth / viewport * 100), 100),
    5
  );
  return `${share}vw`;
}
function srcsetFor(originalSrc) {
  return IMAGE_WIDTH_LADDER.map((w) => {
    const url = cdnImageUrl(originalSrc, w);
    return url ? `${url} ${w}w` : null;
  }).filter(Boolean).join(", ");
}
var EAGER_VIEWPORT_FACTOR = 1.25;
function isNearViewport(el) {
  const rect = el.getBoundingClientRect();
  if (!rect.width && !rect.height) return false;
  return rect.top < window.innerHeight * EAGER_VIEWPORT_FACTOR && rect.bottom > 0;
}
function applyLoadingPriority(img, slot) {
  img.loading = isNearViewport(slot || img) ? "eager" : "lazy";
}
function markBanner(img) {
  img.classList.add(BANNER_IMAGE_CLASS);
  const link = img.closest("a");
  if (link) link.classList.add(BANNER_CLASS);
}
function optimiseInjectedImage(img) {
  if (img.dataset[OPTIMISED_FLAG]) return;
  if (!img.matches(AC_BANNER_SELECTOR) || img.hasAttribute("srcset")) {
    img.dataset[OPTIMISED_FLAG] = "skipped";
    return;
  }
  markBanner(img);
  const originalSrc = img.getAttribute("src");
  if (!originalSrc || originalSrc.startsWith("data:")) return;
  const srcset = srcsetFor(originalSrc);
  if (!srcset) {
    img.dataset[OPTIMISED_FLAG] = "true";
    img.loading = "lazy";
    img.decoding = "async";
    return;
  }
  const slotWidth = slotWidthFor(img);
  img.dataset[OPTIMISED_FLAG] = "true";
  img.removeAttribute("src");
  img.loading = "lazy";
  img.decoding = "async";
  img.setAttribute(
    "sizes",
    slotWidth > 1 ? sizesFor(slotWidth) : "(min-width: 750px) 25vw, 50vw"
  );
  img.setAttribute("srcset", srcset);
  img.setAttribute(
    "src",
    cdnImageUrl(
      originalSrc,
      slotWidth > 1 ? targetWidthFor(slotWidth) : MAX_IMAGE_WIDTH
    )
  );
}
function optimiseInjectedImages(root) {
  if (!root) return;
  if (root.tagName === "IMG") {
    optimiseInjectedImage(root);
    return;
  }
  root.querySelectorAll?.("img").forEach(optimiseInjectedImage);
}
function watchForInjectedImages() {
  const containers = document.querySelectorAll(AC_CONTAINER_SELECTOR);
  if (!containers.length) return false;
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          optimiseInjectedImages(node);
        }
      });
    });
  });
  containers.forEach((container) => {
    observer.observe(container, { childList: true, subtree: true });
    optimiseInjectedImages(container);
  });
  return true;
}
if (!watchForInjectedImages()) onDomReady(watchForInjectedImages);
function toggleFacetsDrawer() {
  const drawerEl = document.querySelector("menu-drawer.facets__drawer");
  if (!drawerEl) return;
  const wasOpen = facetsDrawerDetails?.classList.contains("menu-opening");
  if (wasOpen) {
    const details = drawerEl.querySelector("details");
    if (details && !details.hasAttribute("open")) {
      drawerEl.toggleDrawer();
    }
  } else {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
  }
}
function restorePriceFilter() {
  const priceParam = new URL(window.location.href).searchParams.get("price");
  if (!priceParam) return;
  const [minRaw = "", maxRaw = ""] = priceParam.split("~");
  document.querySelectorAll(".facets__price").forEach((priceWrapper) => {
    const gteInput = priceWrapper.querySelector(
      'input[name="filter.v.price.gte"]'
    );
    const lteInput = priceWrapper.querySelector(
      'input[name="filter.v.price.lte"]'
    );
    if (gteInput && minRaw !== "") gteInput.value = minRaw;
    if (lteInput && maxRaw !== "") lteInput.value = maxRaw;
  });
}
function applyPersistedColourFilters() {
  if (!window.Alpine?.store) return null;
  const slugify = (value = "") => value.toString().trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  const hasChosen = localStorage.getItem("wbColour.hasChosenSeason") === "1";
  if (!hasChosen) return null;
  const store = Alpine.store("wbColour");
  if (!store) return null;
  if (store.autoApply === false) return null;
  const { season = [], tone = [] } = store;
  if (!season.length && !tone.length) return null;
  const url = new URL(window.location.href);
  if (url.searchParams.get("__wbColourApplied") === "1") {
    injectPrefilterNotice();
    return null;
  }
  url.searchParams.delete("akeneo_kettlewell_colour_season");
  url.searchParams.delete("akeneo_kettlewell_colour_tone");
  season.forEach(
    (v) => url.searchParams.append("akeneo_kettlewell_colour_season", slugify(v))
  );
  tone.forEach(
    (v) => url.searchParams.append("akeneo_kettlewell_colour_tone", slugify(v))
  );
  url.searchParams.delete("pg");
  url.searchParams.delete("page");
  url.searchParams.set("__wbColourApplied", "1");
  return url;
}
function injectPrefilterNotice() {
  const clearButton = document.querySelector(".facets__clear-button");
  if (!clearButton) return;
  if (document.querySelector(".wb-prefilter-note")) return;
  const note = document.createElement("div");
  note.className = "wb-prefilter-note product-form-filter product-form-filter__info";
  note.textContent = window.advancedCommerce.prefilledSearchTerm;
  clearButton.insertAdjacentElement("beforebegin", note);
}
var FACET_LINK_SELECTOR = "a[data-ghc-filter-id]";
var FACET_CLEAR_SELECTOR = "a[data-clear]";
var knownFacetGroupIds = /* @__PURE__ */ new Set();
var pendingFacetParams = new URLSearchParams(window.location.search);
function debounce(fn, wait) {
  let timeoutId = null;
  const debounced = (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, wait);
  };
  debounced.isPending = () => timeoutId !== null;
  debounced.flush = (...args) => {
    if (timeoutId === null) return;
    clearTimeout(timeoutId);
    timeoutId = null;
    fn(...args);
  };
  return debounced;
}
var debouncedApplyPendingFacets = debounce(applyPendingFacets, 300);
function facetsDrawerRoot() {
  return document.querySelector("menu-drawer.facets__drawer");
}
function collectKnownFacetGroups(root) {
  root.querySelectorAll(".filter-group[data-group-id]").forEach((group) => {
    knownFacetGroupIds.add(group.dataset.groupId);
  });
}
function syncPendingFacetsFromLocation() {
  pendingFacetParams = new URLSearchParams(window.location.search);
}
function isFacetPending(groupId, valueId) {
  return pendingFacetParams.getAll(groupId).includes(valueId);
}
function toggleFacetPending(groupId, valueId) {
  if (!groupId || !valueId) return;
  const values = pendingFacetParams.getAll(groupId);
  const isActive = values.includes(valueId);
  pendingFacetParams.delete(groupId);
  const next = isActive ? values.filter((v) => v !== valueId) : [...values, valueId];
  next.forEach((v) => pendingFacetParams.append(groupId, v));
}
function clearFacetGroupPending(groupId) {
  if (!groupId) return;
  pendingFacetParams.delete(groupId);
}
function clearAllFacetsPending() {
  knownFacetGroupIds.forEach((groupId) => pendingFacetParams.delete(groupId));
}
function refreshFacetLinkStates(root) {
  root.querySelectorAll(FACET_LINK_SELECTOR).forEach((link) => {
    const { parentGroupId: groupId, ghcFilterId: valueId } = link.dataset;
    if (!groupId || !valueId) return;
    const active = isFacetPending(groupId, valueId);
    link.classList.toggle("button--filled", active);
    link.classList.toggle("button--outlined", !active);
  });
}
function facetChipLabel(root, groupId, valueId) {
  const link = root.querySelector(
    `${FACET_LINK_SELECTOR}[data-parent-group-id="${CSS.escape(groupId)}"][data-ghc-filter-id="${CSS.escape(valueId)}"]`
  );
  return link ? link.textContent.replace(/\s+/g, " ").trim() : valueId;
}
function ensureFacetChipsContainer(root) {
  let container = root.querySelector(
    ".active-facets[data-active-facets-context='ghc']"
  );
  if (container) return container;
  container = document.createElement("div");
  container.className = "active-facets";
  container.dataset.activeFacetsContext = "ghc";
  const wrapper = root.querySelector(".drawer__content-wrapper");
  const accordion = wrapper?.querySelector("accordion-default");
  if (accordion) {
    accordion.before(container);
  } else if (wrapper) {
    wrapper.prepend(container);
  }
  return container;
}
function closeIconSvg() {
  const strokeWidth = window.advancedCommerce?.iconStrokeWidth || "1.5";
  const linecap = window.advancedCommerce?.iconCornerShape || "round";
  return `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8L16 16M16 8L8 16" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="${linecap}"/></svg>`;
}
function facetsText(key, fallback) {
  return window.advancedCommerce?.[key] || fallback;
}
function extractResultCount(response, templateKey) {
  const count = response?.templates?.[templateKey]?.product_count;
  return typeof count === "number" ? count : null;
}
function renderFacetChips(root) {
  const container = ensureFacetChipsContainer(root);
  if (!container) return;
  container.innerHTML = "";
  let hasChips = false;
  knownFacetGroupIds.forEach((groupId) => {
    pendingFacetParams.getAll(groupId).forEach((valueId) => {
      hasChips = true;
      const chip = document.createElement("div");
      chip.className = "ghc-chip capitalize";
      const label = document.createElement("span");
      label.className = "ghc-chip__label";
      label.textContent = facetChipLabel(root, groupId, valueId);
      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "ghc-chip__remove js-ghc-chip-remove";
      remove.dataset.groupId = groupId;
      remove.dataset.valueId = valueId;
      remove.setAttribute(
        "aria-label",
        facetsText("removeFilterText", "Remove filter")
      );
      remove.innerHTML = closeIconSvg();
      chip.append(label, remove);
      container.appendChild(chip);
    });
  });
  if (hasChips) {
    const clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "button button--text js-ghc-facets-clear-all";
    clearBtn.textContent = facetsText("clearAllText", "Clear all");
    container.appendChild(clearBtn);
  }
  container.style.display = hasChips ? "" : "none";
}
function updateApplyButtonState(root) {
  const applyBtn = root.querySelector(".js-ghc-facets-apply");
  const label = applyBtn?.querySelector(".facets__apply-button-text");
  if (!label) return;
  label.textContent = facetsResultCount != null ? facetsText("showItemsCountText", "Show {{ count }} items").replace(
    "{{ count }}",
    facetsResultCount
  ) : facetsText("showItemsText", "Show items");
}
function ensureFacetApplyBar(root) {
  let bar = root.querySelector(".drawer__row.drawer__row--buttons");
  if (!bar) {
    const content = root.querySelector(".drawer__content-facets") || root.querySelector(".drawer__content");
    if (!content) return null;
    bar = document.createElement("div");
    bar.className = "drawer__row drawer__row--buttons";
    content.appendChild(bar);
  }
  if (!bar.querySelector(".js-ghc-facets-apply")) {
    const clearAllText = facetsText("clearAllText", "Clear all");
    const applyText = facetsText("showItemsText", "Show items");
    bar.innerHTML = `
            <button type="button" class="button button--full button--outlined facets__clear-button js-ghc-facets-clear-all">${clearAllText}</button>
            <button type="button" class="button button--full button--filled facets__apply-button js-ghc-facets-apply">
                <span class="facets__apply-button-text">${applyText}</span>
                <div class="button__spinner"><div class="lds-ring"><span></span><span></span><span></span><span></span></div></div>
            </button>
        `;
  }
  return bar;
}
function closeFacetsDrawerIfOpen() {
  const drawerEl = facetsDrawerRoot();
  const details = drawerEl?.querySelector("details");
  if (details?.hasAttribute("open")) {
    drawerEl.toggleDrawer();
  }
}
function restoreExpandedFacetGroups(root) {
  if (!expandedFacetGroupIds.size) return;
  root.querySelectorAll("details.facets__accordion-section").forEach((details) => {
    const groupId = details.querySelector("[data-group-id]")?.dataset.groupId;
    if (!groupId || !expandedFacetGroupIds.has(groupId)) return;
    details.setAttribute("open", "");
    details.classList.add("is-active");
    details.querySelector("summary")?.setAttribute("aria-expanded", "true");
    const body = details.querySelector(".facets__accordion-body");
    if (body) body.style.height = "auto";
  });
}
function restoreFacetsDrawerScroll(root) {
  const contentWrapper = root.querySelector(".drawer__content-wrapper") || facetsDrawerRoot()?.querySelector(".drawer__content-wrapper");
  if (!contentWrapper) return;
  requestAnimationFrame(() => {
    contentWrapper.scrollTop = facetsDrawerScrollTop;
  });
}
function bindFacetGroupAccordionTracking(root) {
  root.querySelectorAll("details.facets__accordion-section").forEach((details) => {
    if (details.dataset.ghcAccordionBound === "true") return;
    details.dataset.ghcAccordionBound = "true";
    details.addEventListener("toggle", () => {
      const groupId = details.querySelector("[data-group-id]")?.dataset.groupId;
      if (!groupId) return;
      if (details.open) {
        expandedFacetGroupIds.add(groupId);
      } else {
        expandedFacetGroupIds.delete(groupId);
      }
    });
  });
}
function bindFacetsDrawerScrollTracking(root) {
  const contentWrapper = root.querySelector(".drawer__content-wrapper") || facetsDrawerRoot()?.querySelector(".drawer__content-wrapper");
  if (!contentWrapper || contentWrapper.dataset.ghcScrollBound === "true")
    return;
  contentWrapper.dataset.ghcScrollBound = "true";
  contentWrapper.addEventListener("scroll", () => {
    facetsDrawerScrollTop = contentWrapper.scrollTop;
    lastFacetsDrawerScrollAt = Date.now();
  });
}
function applyFacetsDrawerColorScheme(root) {
  const drawerContent = root.querySelector(".drawer__content-facets") || facetsDrawerRoot()?.querySelector(".drawer__content-facets");
  const scheme = window.advancedCommerce?.drawerColorScheme;
  if (!drawerContent || !scheme) return;
  Array.from(drawerContent.classList).filter((cls) => cls.startsWith("color-scheme-") || cls === "color-scheme").forEach((cls) => drawerContent.classList.remove(cls));
  drawerContent.classList.add(`color-${scheme}`);
}
function repaintFacetDrawer() {
  const root = facetsDrawerRoot();
  if (!root) return;
  refreshFacetLinkStates(root);
  renderFacetChips(root);
  updateApplyButtonState(root);
}
function syncFacetDrawer(root) {
  if (!root) return;
  facetsDrawerDetails = facetsDrawerRoot()?.querySelector("details") ?? null;
  collectKnownFacetGroups(root);
  if (!debouncedApplyPendingFacets.isPending()) {
    syncPendingFacetsFromLocation();
  }
  applyFacetsDrawerColorScheme(root);
  ensureFacetApplyBar(root);
  restoreExpandedFacetGroups(root);
  restoreFacetsDrawerScroll(root);
  bindFacetGroupAccordionTracking(root);
  bindFacetsDrawerScrollTracking(root);
  refreshFacetLinkStates(root);
  renderFacetChips(root);
  renderAppliedFacetsChips(root);
  updateApplyButtonState(root);
}
function applyPendingFacets() {
  const current = new URLSearchParams(window.location.search);
  if (pendingFacetParams.toString() === current.toString()) return;
  const url = new URL(window.location.href);
  url.search = pendingFacetParams.toString();
  url.searchParams.delete("pg");
  url.searchParams.delete("page");
  reloadGraphene(url);
}
function facetGroupsFromParams(params) {
  const groups = /* @__PURE__ */ new Map();
  knownFacetGroupIds.forEach((groupId) => {
    const values = params.getAll(groupId);
    if (values.length) groups.set(groupId, values);
  });
  return groups;
}
function ensureAppliedFacetsContainer(root) {
  let container = root.querySelector(
    ".active-facets[data-active-facets-context='ghc-applied']"
  );
  if (container) return container;
  const inner = root.querySelector(".collection-facets__inner");
  if (!inner) return null;
  container = document.createElement("div");
  container.className = "active-facets";
  container.dataset.activeFacetsContext = "ghc-applied";
  inner.after(container);
  return container;
}
function renderAppliedFacetsChips(root) {
  const container = ensureAppliedFacetsContainer(root);
  if (!container) return;
  container.innerHTML = "";
  const appliedParams = new URLSearchParams(window.location.search);
  const groups = facetGroupsFromParams(appliedParams);
  let hasChips = false;
  groups.forEach((values, groupId) => {
    values.forEach((valueId) => {
      hasChips = true;
      const chip = document.createElement("div");
      chip.className = "ghc-chip capitalize";
      const label = document.createElement("span");
      label.className = "ghc-chip__label";
      label.textContent = facetChipLabel(root, groupId, valueId);
      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "ghc-chip__remove js-ghc-applied-chip-remove";
      remove.dataset.groupId = groupId;
      remove.dataset.valueId = valueId;
      remove.setAttribute(
        "aria-label",
        facetsText("removeFilterText", "Remove filter")
      );
      remove.innerHTML = closeIconSvg();
      chip.append(label, remove);
      container.appendChild(chip);
    });
  });
  if (hasChips) {
    const clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "button button--text js-ghc-applied-clear-all";
    clearBtn.textContent = facetsText("clearAllText", "Clear all");
    container.appendChild(clearBtn);
  }
  container.style.display = hasChips ? "" : "none";
}
function removeAppliedFacetValue(groupId, valueId) {
  const url = new URL(window.location.href);
  const remaining = url.searchParams.getAll(groupId).filter((v) => v !== valueId);
  url.searchParams.delete(groupId);
  remaining.forEach((v) => url.searchParams.append(groupId, v));
  url.searchParams.delete("pg");
  url.searchParams.delete("page");
  reloadGraphene(url);
}
function clearAllAppliedFacets() {
  const url = new URL(window.location.href);
  knownFacetGroupIds.forEach((groupId) => url.searchParams.delete(groupId));
  url.searchParams.delete("pg");
  url.searchParams.delete("page");
  reloadGraphene(url);
}
function facetActivationTarget(target) {
  const el = target?.closest?.(
    `${FACET_LINK_SELECTOR}, ${FACET_CLEAR_SELECTOR}`
  );
  return el && el.closest("menu-drawer.facets__drawer") ? el : null;
}
function handleFacetActivation(el) {
  if (el.matches(FACET_LINK_SELECTOR)) {
    toggleFacetPending(el.dataset.parentGroupId, el.dataset.ghcFilterId);
  } else {
    clearFacetGroupPending(el.dataset.clear);
  }
  repaintFacetDrawer();
  debouncedApplyPendingFacets();
}
document.addEventListener(
  "pointerdown",
  (event) => {
    pendingFacetTap = null;
    if (event.pointerType !== "touch") return;
    if (Date.now() - lastFacetsDrawerScrollAt < 100) return;
    const el = facetActivationTarget(event.target);
    if (!el) return;
    pendingFacetTap = {
      el,
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY
    };
  },
  true
);
document.addEventListener(
  "pointercancel",
  () => {
    pendingFacetTap = null;
  },
  true
);
document.addEventListener(
  "pointerup",
  (event) => {
    const tap = pendingFacetTap;
    pendingFacetTap = null;
    if (!tap || tap.pointerId !== event.pointerId) return;
    if (Math.hypot(event.clientX - tap.x, event.clientY - tap.y) > 10) return;
    suppressFacetClickUntil = Date.now() + 700;
    handleFacetActivation(tap.el);
  },
  true
);
document.addEventListener(
  "click",
  (event) => {
    const el = facetActivationTarget(event.target);
    if (!el) return;
    event.preventDefault();
    event.stopPropagation();
    if (Date.now() < suppressFacetClickUntil) return;
    handleFacetActivation(el);
  },
  true
);
document.addEventListener("click", (event) => {
  const chipRemove = event.target.closest(".js-ghc-chip-remove");
  if (chipRemove) {
    toggleFacetPending(chipRemove.dataset.groupId, chipRemove.dataset.valueId);
    repaintFacetDrawer();
    debouncedApplyPendingFacets();
    return;
  }
  if (event.target.closest(".js-ghc-facets-clear-all")) {
    clearAllFacetsPending();
    repaintFacetDrawer();
    debouncedApplyPendingFacets();
    return;
  }
  if (event.target.closest(".js-ghc-facets-apply")) {
    debouncedApplyPendingFacets.flush();
    closeFacetsDrawerIfOpen();
    return;
  }
  const appliedRemove = event.target.closest(".js-ghc-applied-chip-remove");
  if (appliedRemove) {
    removeAppliedFacetValue(
      appliedRemove.dataset.groupId,
      appliedRemove.dataset.valueId
    );
    return;
  }
  if (event.target.closest(".js-ghc-applied-clear-all")) {
    clearAllAppliedFacets();
  }
});
var HYDRATE_CONCURRENCY = 8;
function waitForColourStore() {
  let hasChosen = false;
  try {
    hasChosen = localStorage.getItem("wbColour.hasChosenSeason") === "1";
  } catch (err) {
    return Promise.resolve();
  }
  if (!hasChosen || window.Alpine?.store) return Promise.resolve();
  return new Promise((resolve) => {
    document.addEventListener("alpine:initialized", resolve, { once: true });
    setTimeout(resolve, 5e3);
  });
}
async function handleResults(kind, response) {
  const results = document.querySelector(
    kind === "search" ? "#search-Results-AC" : "#collections-AC"
  );
  if (!results) return;
  facetsResultCount = extractResultCount(response, kind);
  toggleFacetsDrawer();
  restorePriceFilter();
  syncFacetDrawer(results);
  await waitForColourStore();
  const url = applyPersistedColourFilters();
  if (url) {
    reloadGraphene(url);
    return;
  }
  const paginated = pendingScrollToTop || didPaginationChange();
  pendingScrollToTop = false;
  const restoring = !paginated && hasSavedScroll();
  if (paginated) {
    sessionStorage.removeItem("ac_collection_scroll");
    scrollToResultsTop();
  } else if (restoring) {
    restoreCollectionScroll();
  }
  const onCard = () => {
    if (restoring && !userScrolledDuringLoad) restoreCollectionScroll();
  };
  await hydrateCardsInBatches(results, "ac", HYDRATE_CONCURRENCY, onCard, {
    priorityCount: priorityCardCount(),
    eagerThroughY: restoring ? savedScrollDepth() : 0
  });
  const loader = document.querySelector(".ac-results-loader");
  loader?.remove();
  if (paginated && window.scrollY > 4 && !userScrolledDuringLoad) {
    scrollToResultsTop();
  } else if (restoring && !userScrolledDuringLoad) {
    restoreCollectionScroll();
  }
  if (restoring) sessionStorage.removeItem("ac_collection_scroll");
  normalizeBrowserUrl();
  previousUrl = window.location.href;
}
window.acOnResults = handleResults;
(window.acPendingResults || []).splice(0).forEach(([kind, response]) => handleResults(kind, response));
window.acOnEarlyResults = prefetchFirstScreen;
window.acBuildEarlyResults = buildEarlyResults;
window.acFirstScreenReady = () => prefetchedCards.size ? Promise.all(prefetchedCards.values()) : null;
if (window.acEarlyResultsHtml) prefetchFirstScreen(window.acEarlyResultsHtml);
function onDomReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}
onDomReady(() => {
  window.acReady(() => {
    if (window.advancedCommerce.themeId) {
      $g.init({ theme: window.advancedCommerce.themeId });
    }
    const locale = Shopify.locale + "-" + Shopify.country;
    $g.autocomplete({
      page_context: {
        currency_id: Shopify.currency.active,
        language_id: locale.toLowerCase()
      },
      position: function(_input) {
      },
      input_selector: "#search-desktop",
      dropdown_selector: ".acs_auto_popup",
      after_load: () => {
        const dropdown = document.querySelector(".acs_auto_popup");
        if (dropdown) dropdown.classList.add("is-loaded");
      },
      before_load: () => {
        const dropdown = document.querySelector(".acs_auto_popup");
        if (dropdown) dropdown.classList.remove("is-loaded");
      }
    });
  });
});
document.addEventListener("click", (event) => {
  const applyBtn = event.target.closest(".facets__price_apply");
  if (!applyBtn) return;
  const priceWrapper = applyBtn.closest(".facets__price");
  if (!priceWrapper) return;
  const gteInput = priceWrapper.querySelector(
    'input[name="filter.v.price.gte"]'
  );
  const lteInput = priceWrapper.querySelector(
    'input[name="filter.v.price.lte"]'
  );
  if (!gteInput || !lteInput) return;
  const gteRaw = gteInput.value.trim();
  const lteRaw = lteInput.value.trim();
  if (!gteRaw && !lteRaw) {
    alert("Please enter a minimum or maximum price.");
    return;
  }
  const gteValue = gteRaw ? Number(gteRaw) : null;
  const lteValue = lteRaw ? Number(lteRaw) : null;
  const min = gteInput.min ? Number(gteInput.min) : null;
  const max = lteInput.max ? Number(lteInput.max) : null;
  if (gteValue !== null && min !== null && gteValue < min) {
    alert(`Minimum price is \xA3${min}.`);
    return;
  }
  if (lteValue !== null && max !== null && lteValue > max) {
    alert(`Maximum price is \xA3${max}.`);
    return;
  }
  if (gteValue !== null && lteValue !== null && gteValue > lteValue) {
    alert("Minimum price cannot be greater than maximum price.");
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.delete("pg");
  url.searchParams.delete("page");
  const priceParam = `${gteValue ?? ""}~${lteValue ?? ""}`;
  url.searchParams.set("price", priceParam);
  reloadGraphene(url);
});
document.addEventListener("click", (event) => {
  const clearBtn = event.target.closest(".facets__clear-button");
  if (!clearBtn) return;
  const store = window.Alpine?.store?.("wbColour");
  if (!store) return;
  store.autoApply = false;
});
window.hydrateCardsInBatches = hydrateCardsInBatches;
window.hydrateCard = hydrateCard;
window.acResolveModule?.();
